import { CLICK_ACTIONS } from "../../utils/Constant";
import { ColumnHeaderType } from "../../utils/Types";
import { blankValueGetter, convertDate } from "../../utils/Util";

export const BB_SYNC_FAILURE_HEADERS: ColumnHeaderType[] = [
  {
    name: 'Date of Sync Failure',
    field: 'dateofSyncFailure',
    sortable: false,
    valueGetter: (params: any) => {
      return params?.dateofSyncFailure ? convertDate(new Date(params.dateofSyncFailure)) : '-';
    },
    clickable: false,
  },
  {
    name: 'Grievance ID',
    field: 'grievanceId',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
  },
  {
    name: 'BB Error Code',
    field: 'remark',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: CLICK_ACTIONS.VIEW_DETAILS,
  },
  {
    name: 'BB Error Reason',
    field: 'reason',
    sortable: false,
    valueGetter: blankValueGetter,
    clickable: false,
    action: CLICK_ACTIONS.VIEW_DETAILS,
  },
];